import { CheckOutlined, CrownOutlined } from "@ant-design/icons";
import { theme } from "antd";
import { useTranslation } from "react-i18next";
import PlanCard, { PlanFeature } from "./PlanCard";

interface PremiumPlanCardProps {
  onButtonClick?: () => void;
  isCurrentPlan?: boolean;
  isLoading?: boolean;
}

const PremiumPlanCard: React.FC<PremiumPlanCardProps> = ({
  onButtonClick,
  isCurrentPlan,
  isLoading = false,
}) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();

  const paidPlanFeatures: PlanFeature[] = [
    {
      feature: t("subscription_page.features.unlimited_charts_office"),
      included: true,
    },
    {
      feature: t("subscription_page.features.unlimited_charts_cloud"),
      included: true,
    },
    {
      feature: t("subscription_page.features.advanced_export"),
      included: true,
    },
    {
        feature: t("subscription_page.features.custom_branding"),
        included: true,
    },
    {
      feature: t("subscription_page.features.priority_support"),
      included: true,
    },
  ];

  const renderFeatureIcon = (included: boolean) => {
    return included ? (
      <CheckOutlined style={{ color: token.colorSuccess }} />
    ) : null;
  };

  const crownIcon = (
    <CrownOutlined style={{ color: token.colorWarning, fontSize: 20 }} />
  );

  return (
    <PlanCard
      title={t("subscription_page.premium")}
      subtitle={t("subscription_page.for_professionals")}
      price={t("subscription_page.price_premium")}
      buttonText={
        !isCurrentPlan
          ? t("subscription_page.upgrade_now")
          : t("subscription_page.manage_subscription")
      }
      features={paidPlanFeatures}
      icon={crownIcon}
      renderFeatureIcon={renderFeatureIcon}
      isButtonLoading={isLoading}
      isSelected={isCurrentPlan}
      buttonStyles={{
        background: token.colorPrimary,
      }}
      onButtonClick={onButtonClick}
      ribbonText={
        isCurrentPlan
          ? t("subscription_page.your_current_plan")
          : t("subscription_page.recommended")
      }
    />
  );
};

export default PremiumPlanCard;
